import accounts from '../../states/accounts/reducer';
import payees from '../../states/payees/reducer';
import session from '../../states/session/reducer';
import envConfig from '../../states/envConfig/reducer';
import api from '../../states/api/reducer';
import user from '../../states/user/reducer';
import modes from '../../states/modes/reducer';
import calendar from '../../states/calendar/reducer';
import templates from '../../states/templates/reducer';
import notifications from '../../states/notifications/reducer';
import statusMapping from '../../states/statusMapping/reducer';
import validation from '../../states/validation/reducer';
import page from '../../states/page/reducer';
import bacsDebit from '../../states/bacsDebit/reducer';
import bacsCredit from '../../states/bacsCredit/reducer';
import payments from '../../states/payments/reducer';
import batch from '../../states/batch/reducer';
import cancelPayment from '../../states/cancelPayment/reducer';
import managePayments from '../../states/managePayments/reducer';
import addPayeeForm from '../../payees/states/addPayee/reducer';
import addPayeeSuccess from '../../payees/states/addPayeeSuccess/reducer';
import managePayee from '../../managePayee/states/reducer';
import ift from '../../states/ift/reducer';
import rates from '../../states/rates/reducer';
import chaps from '../../states/chaps/reducer';
import capabilities from '../../states/capabilities/reducer';
import payeeSelector from '../../states/payeeSelector/reducer';
import importedPayeesList from '../../states/importedPayeesList/reducer';
import importedPaymentList from '../../states/importedPaymentList/reducer';
import accountPaging from '../../states/accountPaging/reducer';
import retailPayment from '../../retailPayments/states/reducer';
import features from '../../states/features/reducer';
import effectiveWarning from '../../effectiveWarning/state/reducer';
import kapitiTransactions from '../../states/kapitiTransactions/reducer';
import cop from '../../cop/states/reducer';

// Please add any new reducers in aphabetical order
export default {
	accountPaging,
	accounts,
	addPayeeForm,
	addPayeeSuccess,
	api,
	bacsCredit,
	bacsDebit,
	batch,
	calendar,
	cancelPayment,
	capabilities,
	chaps,
	cop,
	effectiveWarning,
	envConfig,
	features,
	ift,
	importedPayeesList,
	importedPaymentList,
	kapitiTransactions,
	managePayee,
	managePayments,
	modes,
	notifications,
	page,
	payees,
	payeeSelector,
	payments,
	rates,
	retailPayment,
	session,
	statusMapping,
	templates,
	user,
	validation,
};
